import gql from 'graphql-tag';

export const startImportJob = gql`
  mutation startImportJob($job: StartImportJobRequest!) {
    startImportJob(job: $job) {
      jobId
    }
  }
`;
